import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "product-catalog"
};
const _hoisted_2 = { class: "product-catalog__categories" };
const _hoisted_3 = { class: "row" };
import { onMounted, ref } from 'vue';
import products from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import env from "../services/AppEnv";
import CategoryTeaser from "./CategoryTeaser.vue";
import events from '@astina/paloma-common-ui/src/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeCatalog',
    setup(__props) {
        const categories = ref([]);
        const trackCategoryClick = (category) => {
            events.$emit('track.click_category', { categoryCode: category.code, categoryName: category.name });
        };
        onMounted(() => {
            if (env.catalog.categories.teasers) {
                products
                    .getCategory(env.catalog.categories.teasers, 1)
                    .then(category => categories.value = category.subCategories || []);
            }
            else {
                products
                    .listCategories()
                    .then(c => categories.value = c);
            }
        });
        return (_ctx, _cache) => {
            return (categories.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                                return (_openBlock(), _createBlock(CategoryTeaser, {
                                    category: category,
                                    key: category.code,
                                    onClick: ($event) => (trackCategoryClick(category))
                                }, null, 8, ["category", "onClick"]));
                            }), 128))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
